module.exports = {
    Categories: 'Categories',
    Collection: 'Collection',
    Collection_ALL: 'ALL',
    Collection_HQ: 'HQ',
    Collection_NY: 'NY',
    USMCARelatedOnly: 'USMCA Related Only',
    NAFTARelatedOnly: 'NAFTA Related Only',
    CROSS: 'CROSS',
    CustomsRulings: 'Customs Rulings',
    CustomsRulingsCROSS: 'Customs Rulings (CROSS)',
    CustomsRulingDetails: 'Customs Ruling Details',
    RulingDate: 'Ruling Date',
    RulingDateFrom: 'Ruling Date From',
    RulingDateTo: 'Ruling Date To',
    RulingNumber: 'Ruling Number',
    RevokedBy: 'Revoked By',
    Revokes: 'Revokes',
    ModifiedBy: 'Modified by',
    Modifies: 'Modifies',
    References: 'References',
    RelatedRulings: 'Related Rulings',
    CopyDescription: 'This information is a duplicate of the data found in the US CROSS (Customs Rulings Online Search System) database.',
    LinkToSource: 'Source',
    Text: 'Text',
    IssuedSince: 'Issued Since',
    Subject: 'Subject',
    SearchCustomsRulings: 'Search Customs Rulings'
};
